import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CrossIcon from 'src/assets/images/CloseProduct.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { setShowNoUsageToReportOrCancelPopup } from 'src/pages/reportUsage/redux/action/actionCreators';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import {
    DialogContentContainer,
    NoUsageHeader,
    NoUsageTitle,
    NoUsageReasonsDiv,
    NoUsageButtonContainer,
    CrossIconImg,
    BackButton,
    NoUsageFooterContainer,
} from './noUsageToReport.styled';
import ArrowLeft from 'src/assets/images/LeftArrowBlue.svg';
import {
    convertDateToISOString,
    removeEmptyFieldsFromObject,
} from 'src/utils/util';
import { sizes } from 'src/styles/Media.styled';
import {
    closeOrderSummaryModalState,
    toggleSearchResult,
} from 'src/pages/orders/redux/actions';
import { unlockOrderFunc } from 'src/pages/reportUsage/redux/saga/dataServices';
import {
    Container,
    Container2,
    ContainerGrid,
    From,
} from 'src/pages/admin/updateProxy/index.styled';
import DatePicker from 'src/common/refactoredComponents/datePicker/DatePicker';
import Calendar from 'src/assets/images/CalendarTodayBlue.svg';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { useTranslation } from 'react-i18next';
import { getDisplayDate, getRddDate } from 'src/utils/dateUtils';
import {
    resetSurgeryDetails,
    setSurgeryDetails,
    setUnknownCheckbox,
    updateSurgery,
} from 'src/pages/scheduleSurgery/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { US_COUNTRY_CODE } from 'src/constants/appConstants';
import { BLACK_FONT_COLOR, FONT_FAMILY_REGULAR, SEMANTIC_TEXT_SMALL_PX, SMALL_TEXT_PX } from '../../../../styles/fonts/MCFontConstants';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';

const UnidPostPoneContainer = forwardRef(({
    cancelSurgeryData,
    backBtnClickHandler,
    isFromOrderDetailsModal,
}, ref) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [selectedReason] = useState(null);

    const [selectedDate, setselectedDate] = useState('');
    const { showSearchModal } = useSelector(
        (state) => state.appliedOrdersSearchReducer
    );
    const {
        surgeryDetails,
        cartData,
        pricingNotes,
        productTemplateUID,
        timeZoneOffset,
        surgeryDateTime,
        unknownCheckbox,
    } = useSelector((state) => ({
        surgeryDetails: state.surgeryReducer.surgeryDetails,
        cartData: state.surgeryReducer.cartData,
        pricingNotes: state.surgeryReducer.pricingNotes,
        productTemplateUID: state.surgeryReducer.productTemplateUID,
        timeZoneOffset: state.surgeryReducer.surgeryDetails.timeZoneOffset,
        surgeryDateTime: state.surgeryReducer.surgeryDetails.surgeryDateTime,
        unknownCheckbox: state.surgeryReducer.unknownCheckbox,
    }));
    const [, setCheckBoxChecked] = useState(unknownCheckbox);
    const shippingDetails = useSelector(
        (state) => state.surgeryReducer.shippingDetails
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const defaultshipToAddress = useSelector((state) => {
        return state.shipToAddressReducer.shipToAddress?.nonTissueAddress;
    });
    const accountIdAddress = useSelector((state) => {
        return state.shipToAddressReducer.shipToAddress.accountId;
    });
    const orderStatusDescription = useSelector(
        (state) =>
            state.surgeryDetailsReducer.surgeryData?.orderStatusDescription
    );
    const minDate = useSelector(
        (state) =>
            state.surgeryDetailsReducer?.surgeryData?.surgeryDetails
                ?.surgeryDateTime
    );
    const notes = useSelector((state) => state.surgeryReducer.notes);
    // const unidPlanStatus = useSelector(
    //     (state) =>
    //         state.orderSummaryReducer.orderBasicDetails?.procedureDetail
    //             ?.unidPlanStatus
    // );
    const loading = useSelector((state) => state.surgeryDetailsReducer.loading);

    useEffectWithErrorLogging(() => {
        return () => {
            dispatch(resetSurgeryDetails());
        };
    }, []);
    // const noUsageReasons = [
    //     {
    //         optionId: 'NON_USE_CANCELLED',
    //         optionLabel: 'Case Cancelled',
    //         showProcedureScreen: false,
    //     },
    //     {
    //         optionId: 'NON_USE_MISC',
    //         optionLabel: 'Usage Via Equity Order',
    //         showProcedureScreen: true,
    //     },
    //     {
    //         optionId: 'NON_USE_COMPETITOR',
    //         optionLabel: 'Competitor Chosen',
    //         showProcedureScreen: false,
    //     },
    //     {
    //         optionId: 'NON_USE_INSTRUMENTS',
    //         optionLabel: 'Instrument Only Surgery',
    //         showProcedureScreen: true,
    //     },
    //     {
    //         optionId: 'UNID_NON_USE',
    //         optionLabel: 'UNiD Non-Use',
    //         showProcedureScreen: true,
    //     },
    //     {
    //         optionId: 'UNID_POSTPONED',
    //         optionLabel: 'UNiD Postponed',
    //         showProcedureScreen: false,
    //     },
    // ];

    const closeNoUsageToReportPopup = (viewProcedure) => {
        dispatch(
            setShowNoUsageToReportOrCancelPopup({
                showNoUsagePopup: false,
                showCancelPopup: false,
                surgeryData: viewProcedure ? cancelSurgeryData : {},
                viewProcedureScreen: viewProcedure,
                cancelReason: viewProcedure ? selectedReason : null,
                isFromOrderDetailsModal,
                showUnidPostponePopup: false,
                showCaseCancelOrPostpone: false,
            })
        );
    };

    const redirectToCalendarOrOrdersPage = () => {
        (cancelSurgeryData?.myCaseRef && cancelSurgeryData?.myCaseRef?.length > 0) && unlockOrderFunc({
            action: 'NoUsageToReport',
            myCaseRefId: cancelSurgeryData?.myCaseRef,
        });
        closeNoUsageToReportPopup(false);
        dispatch(
            closeOrderSummaryModalState({
                myCaseRef: '',
                orderSummaryModal: false,
            })
        );
        if (showSearchModal) {
            dispatch(toggleSearchResult(false));
        }
    };

    // ...existing code...
    
    useImperativeHandle(ref, () => ({
        redirectToCalendarOrOrdersPage
    }), []);

    const handleInputStartDateChange = (date) => {
        if (date === '' || date === null) {
            setselectedDate('');
        } else {
            setselectedDate(date);
            const surgeryDate= convertDateToISOString(
               countryISOCode === COUNTRY_CODE_JAPN &&
                    new Date().getTimezoneOffset() > 0
                    ? new Date(
                          date.getTime() +
                              ((-parseInt(timeZoneOffset* -1) ||
                                  0) *
                                  60000 -
                                  new Date().getTimezoneOffset() * 60000)
                      )
                    : new Date(
                          date.getTime() +
                              ((-parseInt(timeZoneOffset) || 0) *
                                  60000 -
                                  new Date().getTimezoneOffset() * 60000)
                      ),
                'original'
            );
            date.setHours(new Date(surgeryDateTime).getHours());
            date.setMinutes(new Date(surgeryDateTime).getMinutes());
            dispatch(
                setSurgeryDetails({
                   sugeryDateAccountTimeZone :surgeryDate ,
                     surgeryDateTime: date.toISOString().split('.')[0] + 'Z',
                })
            );
            setCheckBoxChecked(false);
        }
    };

    const saveSurgeryAndExit = () => {
        // if (orderStatusDescription === 'Draft Not Submitted') {
        //     const surgery = {
        //         surgeryDetails: {
        //             surgeryDateTime: surgeryDateTime,
        //             sugeryDateAccountTimeZone: sugeryDateAccountTimeZone,
        //         },
        //         isSubmitted: false,
        //         isUnidPostponedFlow: true,
        //         visualInspectionAcknowledgement: true,
        //     };
        //     dispatch(updateSurgery(surgery));
        // } else {
        const surgeryDetailsFormatted = removeEmptyFieldsFromObject({
            ...surgeryDetails,
            patientDOB: surgeryDetails.patientDOB
                ? getRddDate(surgeryDetails.patientDOB, 'YYYY-MM-DD')
                : '',
            patientContactNumber:
                countryISOCode === US_COUNTRY_CODE
                    ? surgeryDetails.patientContactNumber.replace(/\D/g, '')
                    : surgeryDetails.patientContactNumber.replace(
                          /[a-zA-Z]/g,
                          ''
                      ),
        });
        delete surgeryDetailsFormatted.inventoryShipping;
        delete surgeryDetailsFormatted.uniDId;
        delete surgeryDetailsFormatted.planStatus;
        delete surgeryDetailsFormatted.lastModifiedDate;
        delete surgeryDetailsFormatted.lastModifiedBy;
        delete surgeryDetailsFormatted.accountName;
        delete surgeryDetailsFormatted.physicianName;
        delete surgeryDetailsFormatted.accountTimeZone;
        delete surgeryDetailsFormatted.timeZoneOffset;

        const clonedCartData = JSON.parse(JSON.stringify(cartData));
        const cartDataFormatted = removeEmptyFieldsFromObject({
            ...clonedCartData,
        });
        cartDataFormatted.products = cartDataFormatted.products
            .filter((product) => product.quantity > 0)
            .map((product) => {
                delete product.brand;
                delete product.dailyRate;
                delete product.description;
                delete product.isSet;
                delete product.salesOrg;
                delete product.uom;
                delete product.error;
                !product.batchAlreadyAllocated &&
                    delete product.batchAlreadyAllocated;
                !product.batchCurrentLocation &&
                    delete product.batchCurrentLocation;
                !product.batchId && delete product.batchId;
                !product.batchParked && delete product.batchParked;
                return product;
            });

        delete cartDataFormatted.templateUId;
        const modifyShippingData = Object.values(shippingDetails).filter(
            (item) => item.shippingAddressId !== ''
        );
        const surgeryTempUID = surgeryDetails?.template?.templateUID
            ? surgeryDetails?.template?.templateUID
            : '';

        const prodTempUID =
            surgeryTempUID.trim() !== '' && productTemplateUID.trim() !== ''
                ? ',' + productTemplateUID
                : surgeryTempUID.trim() === '' &&
                  productTemplateUID.trim() !== ''
                ? productTemplateUID
                : '';

        const tempTemplateUId = surgeryTempUID + prodTempUID;
        surgeryDetails?.accountId == accountIdAddress &&
            modifyShippingData.map((ele) => {
                return {
                    ...ele,
                    shippingAddressId: defaultshipToAddress[0].addressId,
                };
            });
        cartDataFormatted.products = cartDataFormatted.products.map(
            (product) => {
                product.isFeedAddedLPSet = product?.isFeedAddedLPSet
                    ? product.isFeedAddedLPSet
                    : false;
                product.dontSendToSAP = product?.isFeedAddedLPSet
                    ? modifyShippingData && modifyShippingData?.length > 0
                        ? false
                        : true
                    : false;
                return product;
            }
        );

        const surgery = {
            surgeryDetails: surgeryDetailsFormatted,
            shippingDetails: modifyShippingData,
            cartData: {
                ...cartDataFormatted,
                templateUId:
                    tempTemplateUId?.trim().length > 0
                        ? tempTemplateUId.split(',')
                        : [],
            },
            notes: notes,
            pricingNotes: pricingNotes,
            isSubmitted:
                orderStatusDescription ===
                t('orders.orderStatuses.draftNotSubmitted')
                    ? false
                    : true,
            isUnidPostponedFlow: true,
            visualInspectionAcknowledgement: true,
        };
        surgery.myCASERef = cancelSurgeryData.myCaseRef;
        surgery.isSubmittedFromSurgeryFlow = false;
        dispatch(updateSurgery(surgery));
        // }
        redirectToCalendarOrOrdersPage();
    };

    return (
        <React.Fragment>
            <DialogContentContainer>
                <NoUsageHeader>
                    <NoUsageTitle>
                        {t('orders.orderStatuses.UNiDPostponed')}
                    </NoUsageTitle>
                    {/* <CrossIconImg
                        path={CrossIcon}
                        onClick={redirectToCalendarOrOrdersPage}
                    /> */}
                </NoUsageHeader>
                <BackButton 
                id={`reportUsage-noUsageToReport-backButton-${cancelSurgeryData?.myCaseRef || 'unknown'}`}
                onClick={() => backBtnClickHandler(false)}>
                    <img src={ArrowLeft}></img>
                    <span>{t('noUsageToReport.BackLabel')}</span>
                </BackButton>
                {!loading ? (
                    <div>
                        <NoUsageReasonsDiv>
                            <Container
                                container
                                justifyContent={'space-between'}
                                direction="row"
                            >
                                <ContainerGrid
                                    item
                                    xs={12}
                                    sm={3}
                                    md={6}
                                    lg={6}
                                    xl={6}
                                    mobile={12}
                                >
                                    <From>
                                        {t('noUsageToReport.surgeryDate')}
                                    </From>
                                    <Container2>
                                        <DatePicker
                                            datePickerCalendarIcon={Calendar}
                                            minDate={new Date(minDate)}
                                            // // maxDate={new Date(selectedEndDate)}
                                            onChange={(date) =>
                                                handleInputStartDateChange(date)
                                            }
                                            selectedDateFromDatePicker={
                                                selectedDate
                                            }
                                            placeholder={t(
                                                'common.surgeryDateLabel'
                                            )}
                                            fontSize="16px"
                                            left="10px"
                                            mobileHeight="40px"
                                            yearRange={`${new Date().getFullYear()}:2050`}
                                            datePickerBgColor={
                                                unknownCheckbox
                                                    ? '#F1F1F1'
                                                    : 'unset'
                                            }
                                            reportUsage={unknownCheckbox}
                                            datePickerDivWidth="200px"
                                            datePickerDivHeight="40px"
                                            iconHeight={'auto'}
                                            border={'2px solid #EBEDED'}
                                            textOpacity={0.5}
                                            Zindex={99999}
                                            datePickerDivMbWidth={'217px'}
                                            datePickerDivMbHeight={'40px'}
                                            disabled={unknownCheckbox}
                                        />
                                        <div
                                            style={{
                                                position: 'relative !important',
                                            }}
                                        />
                                    </Container2>
                                </ContainerGrid>
                                <ContainerGrid
                                    item
                                    xs={12}
                                    sm={3}
                                    md={6}
                                    lg={6}
                                    xl={6}
                                    mobile={12}
                                    key={'unknown'}
                                    ipadMarginRight={'8% !important'}
                                    style={{ marginTop: '40px' }}
                                >
                                    <Checkbox
                                        checked={unknownCheckbox}
                                        labelStyleObj={{
                                            fontFamily:
                                                FONT_FAMILY_REGULAR,
                                            textAlign: 'left',
                                            fontSize: SMALL_TEXT_PX,
                                            letterSpacing: '-0.11px',
                                            color: BLACK_FONT_COLOR,
                                            opacity: 1,
                                            paddingLeft: SEMANTIC_TEXT_SMALL_PX,
                                            lineHeight:
                                                window.innerWidth <=
                                                    sizes.mobileDevice &&
                                                '20px',
                                        }}
                                        onCheckboxSelectionChange={(e) => {
                                            setselectedDate('');
                                            setCheckBoxChecked(
                                                e.target.checked
                                            );
                                            dispatch(
                                                setUnknownCheckbox(
                                                    e.target.checked
                                                )
                                            );
                                            const date = new Date('01/01/2050');
                                            const surgeryDate =
                                                convertDateToISOString(
                                                    new Date(
                                                        date.getTime() +
                                                            ((-parseInt(
                                                                timeZoneOffset
                                                            ) || 0) *
                                                                60000 -
                                                                new Date().getTimezoneOffset() *
                                                                    60000)
                                                    ),
                                                    'original'
                                                );
                                            date.setHours(
                                                new Date(
                                                    surgeryDateTime
                                                ).getHours()
                                            );
                                            date.setMinutes(
                                                new Date(
                                                    surgeryDateTime
                                                ).getMinutes()
                                            );
                                            dispatch(
                                                setSurgeryDetails({
                                                    surgeryDateTime:
                                                        date
                                                            .toISOString()
                                                            .split('.')[0] +
                                                        'Z',
                                                    sugeryDateAccountTimeZone:
                                                        surgeryDate,
                                                })
                                            );
                                        }}
                                        disabled={selectedDate != ''}
                                        isLabelClick={!selectedDate}
                                        id={'unknown'}
                                        label={t('noUsageToReport.unknown')}
                                        checkedBgColor={'#495057'}
                                    />
                                </ContainerGrid>
                            </Container>
                        </NoUsageReasonsDiv>
                        <NoUsageFooterContainer>
                            <NoUsageButtonContainer>
                                <Button
                                    id={'reportUsage-noUsageToReport-cancelButton'}
                                    show
                                    width={
                                        window.innerWidth <= sizes.mobileDevice
                                            ? '160px'
                                            : '102px'
                                    }
                                    height={'38px'}
                                    //cancel
                                    variant={ButtonStyles.cancel}
                                    // borderRadius={'19px'}
                                    margin={'0px'}
                                    // fontSize={'15px'}
                                    // fontFamily={'AvenirNextWorld Demi'}
                                    clicked={redirectToCalendarOrOrdersPage}
                                >
                                    {t('noUsageToReport.cancelButton')}
                                </Button>
                                <Button
                                    show
                                    width={
                                        window.innerWidth <= sizes.mobileDevice
                                            ? '160px'
                                            : '144px'
                                    }
                                    height={'38px'}
                                    // primary={selectedDate || unknownCheckbox}
                                    variant={(selectedDate || unknownCheckbox) ? ButtonStyles?.primary : ButtonStyles.disabled}
                                    borderRadius={'19px'}
                                    margin={
                                        window.innerWidth >
                                            sizes.mobileDevice &&
                                        '0 35px 0 13px'
                                    }
                                    // fontSize={'15px'}
                                    // fontFamily={'AvenirNextWorld Demi'}
                                    clicked={saveSurgeryAndExit}
                                    disabled={
                                        !(selectedDate || unknownCheckbox)
                                    }
                                >
                                    {t('noUsageToReport.submitButton')}
                                </Button>
                            </NoUsageButtonContainer>
                        </NoUsageFooterContainer>
                    </div>
                ) : (
                    <>
                        <Spinner
                            id="reportUsage-unidPostPoneContainer-loadingSpinner"
                            animation="border"
                            variant="primary"
                            small
                        ></Spinner>
                    </>
                )}
            </DialogContentContainer>
        </React.Fragment>
    );
});

export default UnidPostPoneContainer;
